import { Routes } from '@angular/router';
import { LayoutComponent } from '@layout/layout.component';

export const routes: Routes = [
  {
    path: '',
    component: LayoutComponent,
    children: [
      {
        path: '',
        data: {
          seo: {
            title: 'PT Glori Global Makmur | General Supplier & Hardware Batam',
            description:
              'General supplier & hardware Batam: peralatan las, alat keselamatan kerja, material konstruksi, peralatan listrik, pipa dan katup untuk kebutuhan industri Anda.',
            canonicalPath: '/',
          },
        },
        loadComponent: () =>
          import('@features/home/home.component').then((m) => m.HomeComponent),
      },
      {
        path: 'product',
        data: {
          seo: {
            title: 'Katalog Produk | PT Glori Global Makmur',
            description:
              'Jelajahi katalog produk PT Glori Global Makmur: peralatan las, alat keselamatan, material konstruksi, peralatan listrik, pipa dan katup dari brand terpercaya.',
            canonicalPath: '/product',
          },
        },
        loadComponent: () =>
          import('@features/product/product.component').then(
            (m) => m.ProductComponent
          ),
      },
      {
        path: 'product/:id',
        data: {
          seo: {
            title: 'Detail Produk | PT Glori Global Makmur',
            description:
              'Spesifikasi dan informasi produk dari PT Glori Global Makmur, general supplier dan hardware di Batam untuk kebutuhan industri dan proyek Anda.',
          },
        },
        loadComponent: () =>
          import(
            '@features/product/pages/product-detail/product-detail.component'
          ).then((m) => m.ProductDetailComponent),
      },
      {
        path: 'contact',
        data: {
          seo: {
            title: 'Hubungi Kami | PT Glori Global Makmur',
            description:
              'Hubungi tim PT Glori Global Makmur via WhatsApp, telepon, atau email untuk informasi produk, konsultasi proyek, dan pertanyaan seputar pemesanan.',
            canonicalPath: '/contact',
          },
        },
        loadComponent: () =>
          import('@features/contact/contact.component').then(
            (m) => m.ContactComponent
          ),
      },
      {
        path: '**',
        data: {
          seo: {
            title: 'Halaman Tidak Ditemukan | PT Glori Global Makmur',
            description:
              'Halaman yang Anda cari tidak tersedia. Kembali ke beranda PT Glori Global Makmur untuk melihat katalog produk dan informasi kontak.',
            robots: 'noindex, follow',
          },
        },
        loadComponent: () =>
          import('@features/not-found/not-found.component').then(
            (m) => m.NotFoundComponent
          ),
      },
    ],
  },
];
